import Vue from "vue"
import App from "./app.vue"

import "@/assets/reset.css"

async function BootStrap() {
  new Vue({
    el: "#app",
    render: (h) => h(App)
  })
}

BootStrap()
